import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";


Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV || "development",
  release: process.env.REACT_APP_VERSION || "0.1.0",
  sendDefaultPii: true,
  debug:true,
  integrations: [
    browserTracingIntegration({
      tracingOrigins: ["https://uat-cinepolisgcc.enpointe.io", "https://uae-uat-cinepolisgcc.enpointe.io","https://oman-uat-cinepolisgcc.enpointe.io","https://bahrain-uat-cinepolisgcc.enpointe.io", "https://www.cinepolisgulf.com", "https://uae.cinepolisgulf.com" ,"https://oman.cinepolisgulf.com","https://bahrain.cinepolisgulf.com",],
    }),
  ],
  tracesSampleRate: 1.0,

  beforeSend(event) {
    if (process.env.NODE_ENV === "development") {
    }
    return event;
  },

  ignoreErrors: [
    "Network Error",
    "NetworkError",
    "Non-Error promise rejection captured",
    "fbq is not defined",
  ],
});

export default Sentry;
